import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_VEHICLES_TYPES = {
  'list': [],
};

const INITIAL_STATE_DISPATCH_ORDER_FORM = {
  'dispatchOrder': null,
  'loading': false,
  'approving': false,
  'values': {
    'orderId': '',
    'status': '',
    'statusDescription': '',
    'dealerId': '',
    'anticipatedInvoice': '',
    'type': '',
    'addDate': '',
    'addUser': '',
    'updateDate': '',
    'updateUser': '',
    'vehiclesArray': [],
    'notificateTo': '',
    'sendOrder': false,
    'approveOrder': '',
  },
};

const INITIAL_STATE_CANDIDATES_VEHICLES = {
  'list': [],
};

export const vehiclesTypes = (state, action) => {
  return createReducer(INITIAL_STATE_VEHICLES_TYPES, {
    [ActionTypes.FETCHING_VEHICLES_TYPES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
      'list': [],
    }),
    [ActionTypes.FETCHED_VEHICLES_TYPES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.FETCHED_VEHICLES_TYPES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
  })(state, action);
};

export const candidateVehicles = (state, action) => {
  return createReducer(INITIAL_STATE_CANDIDATES_VEHICLES, {
    [ActionTypes.FETCHING_CANDIDATES_VEHICLES]: (state, action) => ({
      ...state,
      'loading': true,
      'list': [],
    }),
    [ActionTypes.FETCHED_CANDIDATES_VEHICLES]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_CANDIDATES_VEHICLES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_CANDIDATES_VEHICLES]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const dispatchOrderForm = (state, action) => {
  return createReducer(INITIAL_STATE_DISPATCH_ORDER_FORM, {
    [ActionTypes.FETCHING_DISPATCH_ORDER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_DISPATCH_ORDER]: (state, action) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'orderId': action.response.data[0].orderId,
        'status': action.response.data[0].status,
        'statusDescription': action.response.data[0].statusDescription,
        'dealerId': action.response.data[0].dealerId,
        'anticipatedInvoice': action.response.data[0].anticipatedInvoice,
        'type': action.response.data[0].type,
        'addDate': action.response.data[0].addDate,
        'addUser': action.response.data[0].addUser,
        'updateDate': action.response.data[0].updateDate,
        'updateUser': action.response.data[0].updateUser,
        'vehiclesArray': action.response.data[0].vehiclesArray,
        'notificateTo': action.response.data[0].notificateTo,
        'sendOrder': false,
      },
    }),
    [ActionTypes.FETCHED_DISPATCH_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'values': {
        'dealerId': action.response.data[0].dealerId,
      },
    }),
    [ActionTypes.APPROVING_DISPATCH_ORDER]: (state, action) => ({
      ...state,
      'approving': true,
    }),
    [ActionTypes.APPROVED_DISPATCH_ORDER]: (state, action) => ({
      ...state,
      'approving': false,
    }),
    [ActionTypes.APPROVED_DISPATCH_ORDER_FAILED]: (state, action) => ({
      ...state,
      'approving': false,
    }),
    [ActionTypes.CLEAR_DISPATCH_ORDER]: (state, action) => ({
      ...state,
      'loading': false,
      'values': {
        'orderId': '',
        'status': '',
        'statusDescription': '',
        'dealerId': '',
        'anticipatedInvoice': '',
        'type': '',
        'addDate': '',
        'addUser': '',
        'updateDate': '',
        'updateUser': '',
        'vehiclesArray': [],
        'notificateTo': '',
        'sendOrder': false,
        'approveOrder': '',
      },
    }),
    [ActionTypes.CANCELLING_DISPATCH_ORDER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CANCELLED_DISPATCH_ORDER]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CANCELLED_DISPATCH_ORDER]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
